import { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import { RecommendationTarget } from '../types';
import RecommendeeHeader from '../components/RecommendeeHeader';
import FileViewer from './FileViewer';
import Spinner from './Spinner';
import { getFileKey, getPresignedUrl } from '../utils';

interface RecommendationViewFileProps {
    target: RecommendationTarget;
    onClose: () => void;
    setIsReuploadIntentActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const RecommendationViewFile: React.FC<RecommendationViewFileProps> = ({ target, onClose, setIsReuploadIntentActive }) => {
    const [fileUrl, setFileUrl] = useState('');
    const fileKey = getFileKey(target);

    useEffect(() => {
        (async () => {
            const presignedURL = await getPresignedUrl(fileKey);
            setFileUrl(presignedURL);
        })();
    }, [target, fileKey]);

    console.log(fileUrl);

    return (
        <Stack padding="32px" spacing={3}>
            <RecommendeeHeader target={target} onClose={onClose} setIsReuploadIntentActive={setIsReuploadIntentActive} />
            {fileUrl ? <FileViewer fileInfo={{ url: fileUrl, filename: fileKey }} height={1000} /> : <Spinner size={96} />}
        </Stack>
    );
};

export default RecommendationViewFile;